export default {
  getbookMarks: {},
  selectedbookMarks: {},
};
